<template>
  <div id="fullPageLoader" v-if="loader.active" >
    <transition name="fade">
      <div class="wrapper">
        <div class="closeloader"><button class="subtleButton" @click="closeFullPageLoader">Close</button></div>
        <div v-html="loader.message"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import {store} from '@/store'

export default {
  name: 'FullPageLoader',
  computed: {
    loader () {
      return store.state.fullPageLoader
    }
  },
  methods: {
    closeFullPageLoader () {
      store.commit('setFullPageLoader', {
        active: false,
        message: 'Loading'
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/variables/variables';
  #fullPageLoader {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: $brandGreen75;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
    color: white;
    font-size: 2.4rem;
    .subtleButton {
      color: white;
    }
  }
  .closeloader {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/FullPageLoader.vue